import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Box,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Grid,
    InputAdornment,
    Chip,
    IconButton,
    Typography,
    Autocomplete,
} from "@mui/material";
import {
    CloseOutlined,
    KeyboardArrowDownRounded,
} from "@mui/icons-material";
import Popover from "@mui/material/Popover";
import {
    job_types_data,
    us_states_data,
    visa_types_data,
} from "./Commondata";
import logoImg from "../../Components/images/logo.png";
import CustomLoadingButton from "./Customloadingbutton";
import { getValidValueReturnNull } from "./valuevalidations";
import Key from "../../clientVariables.json";
import { getCitiesAction, getCountriesAction, getStatesAction } from "../redux/action";
import { appSelector } from "../redux/selector";
import { useDispatch, useSelector } from "react-redux";

const PreferencesModal = ({ modalState, onClose, onSubmit }) => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [zipcodes, setZipcodes] = useState([]);
    const [formValues, setFormValues] = useState({
        visaType: [],
        jobType: [],
        currentRate: "",
        expectedRate: "",
        address: "",
        willingRelocate: false,
        currentlyOnProject: false,
        state: "",
        city: "",
        zipcode: "",
        rateType: "hour",
        relatedTitles: [],
        noticePeriod: "",
        experience: "",
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const primaryResumeDetails_ = useSelector(
        (state) => state.primaryResumeReducer?.resume
    );
    const [primaryResumeDetails, setPrimaryResumeDetails] = useState(
        primaryResumeDetails_
    );
    const [cityList, setCityList] = useState([]);

    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);

    useEffect(() => {
        if (
            modalState?.initialData &&
            Object.keys(modalState?.initialData)?.length > 0
        ) {
            setPrimaryResumeDetails(modalState?.initialData);
        }
    }, [modalState?.initialData]);

    useEffect(() => {
        const initialData = modalState?.initialData;
        const selectedState = us_states_data.find(
            (state) => state.id == initialData?.location_state
        );
        if (initialData) {
            setFormValues((prevFormValues) => ({
                ...prevFormValues,
                jobType: getValidValueReturnNull(initialData?.jobtype)
                    ? initialData?.jobtype?.split(",").map((num) => Number(num.trim()))
                    : [],
                visaType: getValidValueReturnNull(initialData?.visatype)
                    ? initialData?.visatype?.split(",").map((num) => Number(num.trim()))
                    : [],
                currentRate: getValidValueReturnNull(initialData?.jobsalaryrangestart)
                    ? Number(initialData?.jobsalaryrangestart)
                    : null,
                expectedRate: getValidValueReturnNull(initialData?.desiredsalarystart)
                    ? Number(initialData?.desiredsalarystart)
                    : null,
                willingRelocate: getValidValueReturnNull(
                    initialData?.willing_to_relocate
                )
                    ? Boolean(initialData?.willing_to_relocate)
                    : false,
                state: selectedState?.id || "",
                rateType: getValidValueReturnNull(initialData?.salary_type)
                    ? initialData?.salary_type === "annum"
                        ? "annum"
                        : "hour"
                    : null,
                relatedTitles: getValidValueReturnNull(initialData?.solr_search_string)
                    ? initialData?.solr_search_string
                        ?.split(",")
                        .map((title) => title.trim())
                    : [],
                noticePeriod: parseInt(
                    primaryResumeDetails?.notice_period?.match(/\d+/)?.[0],
                    10
                ),
                experience: primaryResumeDetails?.total_experience,
            }));
        }
    }, [modalState]);

    useEffect(() => {
        if (formValues.state) {
            getCities(formValues.state);
        } else {
            setCityList([]);
        }
    }, [formValues.state, modalState?.initialData]);

    useEffect(() => {
        const initialData = modalState?.initialData;
        if (initialData?.address_city && cityList.length > 0) {
            const selectedCity = cityList.find(
                (city) => city.id == initialData?.address_city
            );
            if (selectedCity) {
                setFormValues((prev) => ({
                    ...prev,
                    city: selectedCity.id,
                }));
            }
        }
    }, [cityList, modalState?.initialData]);

    const handleInputChange = (field, value) => {
        setFormValues((prev) => {
            if (field === "jobType" || field === "visaType") {
                // Make sure prev[field] is an array before calling includes or filter
                const currentValues = Array.isArray(prev[field]) ? prev[field] : [];
                // Handle toggling for multiple selection fields
                const updatedValues = currentValues.includes(value)
                    ? currentValues.filter((item) => item !== value) // Remove if already selected
                    : [...currentValues, value]; // Add if not already selected

                return { ...prev, [field]: updatedValues };
            }

            return { ...prev, [field]: value };
        });

        // Clear error for the specific field
        setErrors((prev) => ({
            ...prev,
            [field]: null,
        }));
        validateForm();
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && event.target.value.trim()) {
            setFormValues((prevFormValues) => ({
                ...prevFormValues,
                relatedTitles: [
                    ...(prevFormValues.relatedTitles || []),
                    event.target.value.trim(),
                ],
            }));
            event.target.value = "";
        }
    };

    const handleDelete = (title) => () => {
        setFormValues((prevFormValues) => {
            if (!Array.isArray(prevFormValues.relatedTitles) || !prevFormValues.relatedTitles?.length)
                return { ...prevFormValues, relatedTitles: [] };
            return {
                ...prevFormValues,
                relatedTitles: prevFormValues.relatedTitles?.filter((s) => s !== title),
            };
        });
    };

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleOptionSelect = (option) => {
        setFormValues((prev) => ({ ...prev, rateType: option }));
        handlePopoverClose();
    };

    const open = Boolean(anchorEl);


    const getCities = (id) => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_cities_by_stateid`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                state_id: id,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setCityList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const validateForm = () => {
        const newErrors = {};

        // if (!Array.isArray(formValues.visaType) || formValues.visaType.length === 0)
        //     newErrors.visaType = "Work Authorization is required.";
        if (!Array.isArray(formValues.jobType) || formValues.jobType.length === 0)
            newErrors.jobType = "Job Type is required.";
        if (!formValues.state) newErrors.state = "State is required.";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            onSubmit(formValues);
            onClose();
        }
    };

    return (
        <Dialog
            open={modalState?.open === "preferences" && modalState?.isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: "10px 22px 0px 22px",
                }}
            >
                <Box sx={{ display: "flex" }}>
                    <Box sx={{}}>
                        <img src={logoImg} width={120} alt="Company Logo" />
                    </Box>
                </Box>
                <Box>
                    <IconButton aria-label="close-modal" onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </Box>
            </Box>
            <DialogTitle>Preferences</DialogTitle>
            <DialogContent>
                <Box sx={{}}>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={12} md={6}>
                            <Autocomplete
                                multiple
                                limitTags={1}
                                id="visa-type-autocomplete"
                                options={visa_types_data || []}
                                getOptionLabel={(option) => option.type_code || ""}
                                value={(Array.isArray(formValues.visaType) ? formValues.visaType : [])
                                    .map((id) => visa_types_data.find((data) => data.id === id))
                                    .filter(Boolean)}
                                onChange={(event, newValue) =>
                                    setFormValues((prev) => ({
                                        ...prev,
                                        visaType: newValue.map((item) => item.id),
                                    }))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Work Authorization"
                                        variant="standard"
                                        placeholder="Select visa types"
                                        error={Boolean(errors.visaType)}
                                        size="small"
                                    />
                                )}
                                sx={{ width: "100%" }}
                            />
                        </Grid>  */}
                        <Grid item xs={12} md={12}>
                            <Autocomplete
                                multiple
                                limitTags={1}
                                id="job-type-autocomplete"
                                options={job_types_data || []}
                                getOptionLabel={(option) => option.title || ""}
                                value={(Array.isArray(formValues.jobType) ? formValues.jobType : [])
                                    .map((id) => job_types_data.find((data) => data.id === id))
                                    .filter(Boolean)}
                                onChange={(event, newValue) =>
                                    setFormValues((prev) => ({
                                        ...prev,
                                        jobType: newValue.map((item) => item.id),
                                    }))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Job Type*"
                                        variant="standard"
                                        placeholder="Select job types"
                                        error={Boolean(errors.jobType)}
                                        size="small"
                                    />
                                )}
                                sx={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="dense"
                                label="Current Rate (USD)"
                                type="number"
                                value={formValues.currentRate}
                                onChange={(e) =>
                                    handleInputChange("currentRate", e.target.value)
                                }
                                fullWidth
                                variant="standard"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">$</InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Box
                                                onClick={handlePopoverOpen}
                                                sx={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#00000099",
                                                        borderRadius: "4px",
                                                        px: 0.5,
                                                        userSelect: "none",
                                                    }}
                                                >
                                                    /{formValues.rateType}
                                                </Typography>
                                                <KeyboardArrowDownRounded
                                                    sx={{ color: "#00000099", fontSize: "14px" }}
                                                />
                                            </Box>
                                        </InputAdornment>
                                    ),
                                    inputProps: {
                                        min: 0,
                                        step: "1",
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="dense"
                                label="Expected Rate (USD)"
                                type="number"
                                value={formValues.expectedRate}
                                onChange={(e) =>
                                    handleInputChange("expectedRate", e.target.value)
                                }
                                fullWidth
                                variant="standard"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">$</InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Box
                                                onClick={handlePopoverOpen}
                                                sx={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#00000099",
                                                        borderRadius: "4px",
                                                        px: 0.5,
                                                        userSelect: "none",
                                                    }}
                                                >
                                                    /{formValues.rateType}
                                                </Typography>
                                                <KeyboardArrowDownRounded
                                                    sx={{ color: "#00000099", fontSize: "14px" }}
                                                />
                                            </Box>
                                        </InputAdornment>
                                    ),
                                    inputProps: {
                                        min: 0,
                                        step: "1",
                                    },
                                }}
                            />
                            <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handlePopoverClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                            >
                                <Box sx={{ p: 1, width: "120px" }}>
                                    {["hour", "annum"].map((option) => (
                                        <Typography
                                            key={option}
                                            onClick={() => handleOptionSelect(option)}
                                            sx={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                "&:hover": {
                                                    backgroundColor: "#f0f0f0",
                                                },
                                            }}
                                        >
                                            /{option}
                                        </Typography>
                                    ))}
                                </Box>
                            </Popover>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                margin="dense"
                                id="experience"
                                name="experience"
                                label="Total Experience"
                                type="number"
                                fullWidth
                                variant="standard"
                                value={formValues.experience}
                                onChange={(e) =>
                                    handleInputChange("experience", e.target.value)
                                }
                                error={!!errors.experience}
                                helperText={
                                    errors.experience || "Enter experience in years (e.g., 4.5)"
                                }
                                inputProps={{
                                    step: "0.1",
                                    min: "0",
                                }}
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">Years</InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="dense"
                                id="noticePeriod"
                                name="noticePeriod"
                                label="Notice Period"
                                type="number"
                                fullWidth
                                variant="standard"
                                value={formValues.noticePeriod}
                                onChange={(e) =>
                                    handleInputChange("noticePeriod", e.target.value)
                                }
                                error={!!errors.noticePeriod}
                                helperText={
                                    errors.noticePeriod ||
                                    "Enter notice period in days (e.g., 30)"
                                }
                                inputProps={{
                                    step: "1",
                                    min: "0",
                                }}
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">Days</InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                select
                                label="Country"
                                value="USA"
                                fullWidth
                                variant="standard"
                                size="small"
                                disabled
                            >
                                <MenuItem key="USA" value="USA">
                                    United States Of America
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <Autocomplete
                                options={us_states_data}
                                getOptionLabel={(option) => option.name}
                                value={
                                    us_states_data.find(
                                        (state) => state.id === formValues.state
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    handleInputChange("state", newValue ? newValue.id : "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="State"
                                        variant="standard"
                                        fullWidth
                                        required
                                        size="small"
                                        error={Boolean(errors.state)}
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <Autocomplete
                                options={cityList || []}
                                getOptionLabel={(option) => option.cityName || ""}
                                value={
                                    cityList?.find((city) => city.id === formValues.city) || null
                                }
                                onChange={(event, newValue) =>
                                    handleInputChange("city", newValue ? newValue.id : "")
                                }
                                disabled={!formValues.state}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="City"
                                        variant="standard"
                                        fullWidth
                                        size="small"
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formValues.currentlyOnProject}
                                        onChange={(e) =>
                                            handleInputChange("currentlyOnProject", e.target.checked)
                                        }
                                        size="small"
                                    />
                                }
                                label="Currently On Project"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formValues.willingRelocate}
                                        onChange={(e) =>
                                            handleInputChange("willingRelocate", e.target.checked)
                                        }
                                        size="small"
                                    />
                                }
                                label="Willing Relocate"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Related Titles"
                                fullWidth
                                variant="standard"
                                onKeyDown={handleKeyDown}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">+</InputAdornment>
                                    ),
                                }}
                                helperText="Type a title and press Enter to add it to the list."
                                sx={{ mt: 2 }}
                                FormHelperTextProps={{
                                    sx: {
                                        color: "blue",
                                    },
                                }}
                            />

                            <Box sx={{ mt: 2 }}>
                                {Array.isArray(formValues.relatedTitles) && formValues.relatedTitles.map((title, index) => (
                                    <Chip
                                        key={index}
                                        label={title}
                                        onDelete={handleDelete(title)}
                                        sx={{ m: 0.5 }}
                                    />
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            {Object.keys(errors).length > 0 && (
                <Box
                    sx={{
                        mt:3,
                        px: 3,
                        pb: 1,
                        display: "flex",
                        justifyContent: "flex-start",
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: "red",
                        }}
                    >
                        * All mandatory fields are required
                    </Typography>
                </Box>
            )}
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <CustomLoadingButton
                    loading={modalState?.loading}
                    success={modalState?.success}
                    onClick={handleSubmit}
                >
                    Save
                </CustomLoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default PreferencesModal;